import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import GroupIcon from '@mui/icons-material/Group';
import WorkIcon from '@mui/icons-material/Work';
import LabelIcon from '@mui/icons-material/Label';
import DescriptionIcon from '@mui/icons-material/Description';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';

const ADMIN_ROUTES = [
  {
    path: '/admin/dashboard/orgs',
    name: 'Organizations',
    icon: <CorporateFareIcon fontSize="medium" />,
    collapse: false,
  },
  {
    path: '/admin/dashboard/contracts',
    name: 'Contracts',
    icon: <HistoryEduIcon fontSize="medium" />,
    collapse: false,
  },
  {
    path: '/admin/dashboard/users',
    name: 'Users',
    icon: <GroupIcon fontSize="medium" />,
    collapse: false,
  },
  {
    path: '/admin/dashboard/employments',
    name: 'Employments',
    icon: <WorkIcon fontSize="medium" />,
    collapse: false,
  },
  {
    path: '/admin/dashboard/reports-templates',
    name: 'Reports Templates',
    icon: <AssignmentIndIcon fontSize="medium" />,
    collapse: false,
  },
  {
    path: '/admin/dashboard/fill-data',
    name: 'Fill Data',
    icon: <HistoryEduIcon fontSize="medium" />,
    collapse: false,
  },
  {
    path: '/admin/dashboard/tags',
    name: 'Tags',
    icon: <LabelIcon fontSize="medium" />,
    collapse: false,
  },
  {
    path: '/admin/dashboard/llm-prompts',
    name: 'LLM Prompts',
    icon: <DescriptionIcon fontSize="medium" />,
    collapse: false,
  },
  {
    path: '/admin/dashboard/parsed-issues',
    name: 'Parsed Text for Issues',
    icon: <DescriptionIcon fontSize="medium" />,
    collapse: false,
  },
  {
    path: '/admin/dashboard/llm-privileges',
    name: 'LLM Privileges',
    icon: <TextSnippetIcon fontSize="medium" />,
    collapse: false,
  },
];

export default ADMIN_ROUTES;
